'use strict';

var $ = require('jquery');

function AnchorLinkSmoothScroll(selector) {
	var $scrollBtnEl = $(selector);

	if (!$scrollBtnEl.length) {
		return;
	}

	$scrollBtnEl.on('click.scrollTo', function(event) {
		var targetId = decodeURIComponent($(this).attr('href').match(/#.*/)[0]);

		$('html, body').animate({
			scrollTop: $(targetId).offset().top - 15
		}, 'slow');
	});
}

module.exports = {
	init: function() {
		AnchorLinkSmoothScroll('.page__introLink[href*="#"]');
	}
};